import { useEffect, useState, useMemo } from "react"
import { capitalizeString } from "src/shared/hooks/capitalizeString"
import { useProfile } from "src/shared/hooks/useProfile"
import { puestosRestaurante } from "src/constants/puestos"
import { useFormatDate } from "src/shared/hooks/useFormatDate"

export function useHeader(data) {
    const getFilterOptions = (key: string) => {
        const options: any[] = []

        data?.forEach((item) => {
            let value = ""
            if (key === "numero_habitacion") {
                value = item?.habitacion?.numero_habitacion
            } else {
                value = item?.[key]
            }
            if (value) {
                const find = options.find((item) => item?.value === value)
                if (!find) options.push({ value, valueToDisplay: capitalizeString(value) })
            }
        })

        return options.length > 0 ? [...options] : []
    }

    const headers = useMemo(() => {
        const base = [
            { value: "Folio" },
            { value: "Estatus", filterMenu: getFilterOptions("estado"), isFilterUnique: true },
            { value: "Fecha y hora" },
            { value: "Lugar o responsable", filterMenu: getFilterOptions("area"), isFilterUnique: true },
            { value: "Tipo", filterMenu: getFilterOptions("tipo_incidencia"), isFilterUnique: true },
            { value: "Habitación", filterMenu: getFilterOptions("numero_habitacion"), isFilterUnique: true },
            { value: "Descripción" },
            { value: "Urgencia", filterMenu: getFilterOptions("severidad"), isFilterUnique: true },
        ]
        return base
    }, [data])

    return headers
}


export function useRows(data: any[]) {
    const [rows, setRows] = useState<any[]>([])
    const [saveSearch, setSearch] = useState<string>("")
    const { formatCustomDate } = useFormatDate()
    const { rolName } = useProfile()

    const getRowFormat = (list: any[]) => {
        return list.map((incidencia) => {
            const base = [
                { value: incidencia?.folio },
                { value: capitalizeString(incidencia?.estado) },
                { value: formatCustomDate(incidencia.fecha_registro, "DD/MMM/YYYY HH:mm A") },
                { value: incidencia.area || "-" },
                {
                    value: capitalizeString(incidencia?.tipo_incidencia || "N/A"),
                },
                { value: incidencia?.habitacion?.numero_habitacion || "N/A" },
                { value: capitalizeString(incidencia.detalle || "-") },
                { value: capitalizeString(incidencia?.severidad) },
            ]
            return {
                goTo: incidencia?.incidencia_id,
                value: base,
            }
        })
    }

    useEffect(() => {
        let filteredData = data
        const perfil = {
            VALETPARKING: "Valet parking",
            ROOMSERVICE: "Room service",
            RESTAURANTE: puestosRestaurante,
        }
        if (perfil[rolName]) {
            filteredData = data.filter(
                (incidencia) => incidencia.colaborador_reporta?.puesto?.nombre === perfil[rolName]
            )
        }

        if (filteredData?.length > 0) {
            setRows(getRowFormat(filteredData))
        } else {
            setRows([])
        }
    }, [data.length, rolName])

    const handleFilter = (params: any[]) => {
        const getKeys = (id) => clearParams.filter(({ idx }) => idx === id).map(({ filter }) => filter)
        const findValue = (keys: string[], value: string) => (keys.length > 0 ? keys.includes(value) : true)

        const keyAll = params.filter(({ filter }) => filter === "todas")
        const clearParams =
            keyAll.length === 0 ? params : params.filter(({ idx }) => keyAll.find((item) => item.idx !== idx))
        if (clearParams.length > 0) {
            const results: any[] = []
            const estadoKeys = getKeys(1)
            const lugarKeys = getKeys(3)
            const tipoKeys = getKeys(4)
            const habitacionKeys = getKeys(5)
            const urgenciaKeys = getKeys(8)

            data.forEach((item) => {
                if (
                    findValue(estadoKeys, item?.estado) &&
                    findValue(urgenciaKeys, item?.severidad) &&
                    findValue(lugarKeys, item?.area) &&
                    findValue(tipoKeys, item?.tipo_incidencia) &&
                    findValue(habitacionKeys, item?.habitacion?.numero_habitacion)
                ) {
                    results.push(item)
                }
            })
            setRows(getRowFormat(results))
        } else {
            setRows(getRowFormat(data))
        }
    }

    const handleSearch = (search: string) => {
        setSearch(search)
        if (search) {
            const results = data?.filter(
                (incidencia: any) => {
                    const find = search.toLowerCase()
                    const fecha = formatCustomDate(incidencia.fecha_registro, "DD/MMM/YYYY HH:mm A")
                    const habitacion = incidencia?.habitacion?.numero_habitacion || ""

                    return incidencia?.detalle?.toLowerCase().includes(find) ||  fecha.toLowerCase().includes(find) || (habitacion ? habitacion.toLowerCase().includes(find) : false)
                }
                    
            )
            setRows(getRowFormat(results))
        } else {
            setRows(getRowFormat(data))
        }
    }

    return { rows, search: saveSearch, handleFilter, handleSearch }
}
